import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ReqRoleAdd } from '../../../../item/ItemRole';
import { api_addRole } from '../../../../api/apiRole';
import { api_getCategoryDetail, api_addCategory } from '../../../../api/apiCategory';
import { RespCategoryItem, ReqCategory, ReqCategoryItem } from '../../../../item/ItemCategory';


export function CategoryEdit({ id, type, setIsLoading }) {
  const [categoryId, setCategoryId] = useState("")
  const [categoryName, setCategoryName] = useState("")
  const [categoryPages, setCategoryPages] = useState([])
  const [pages, setPages] = useState([])

  useEffect(() => {
    var rId = Auth.getResume2Token(id)
    setCategoryId(rId)
    if (rId === "") {
      getDetial("")
    }
  }, [])

  useEffect(() => {
    if (categoryId !== undefined && categoryId !== "") {
      getDetial(categoryId)
    }
  }, [categoryId])

  function getDetial(categoryId) {
    setIsLoading(true)
    var mReqCategoryItem = new ReqCategoryItem({ categoryId, type })
    api_getCategoryDetail({
      mReqCategoryItem,
      success: (jsonData) => {
        //console.log(jsonData)
        if (jsonData.detail !== null) {
          var mRespCategoryItem = new RespCategoryItem({})
          mRespCategoryItem.fromJson(jsonData.detail)

          setCategoryName(mRespCategoryItem.categoryName)
          setCategoryPages(mRespCategoryItem.items)
        }
        setPages(jsonData.pages)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }

  function toCancel() {
    window.history.back();
  }

  function toEdit() {
    if (categoryName !== "") {
      var mReqCategory = new ReqCategory({
        categoryId,
        categoryName,
        items: categoryPages,
        type
      })
      api_addCategory({
        mReqCategory,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: categoryId === "" ? '新增成功' : '編輯成功',
          }).then(function () {
            //window.history.replace("/ManagerList");
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err.message,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '類別名稱 不得為空',
      })
    }
  }


  function choose(val) {
    var filterEmpty = pages.filter((page) => {
      //console.log(page)
      return page.pageId === val;
    });
    var list = categoryPages.concat(filterEmpty[0])
    //console.log(list)
    filterEmpty = pages.filter((page) => {
      //console.log(page)
      return page.pageId !== val;
    });
    //console.log(filterEmpty)

    setPages(filterEmpty)
    setCategoryPages(list)
  }

  function unChoose(val) {
    var filterEmpty = categoryPages.filter((page) => {
      //console.log(page)
      return page.pageId === val;
    });
    var list = pages.concat(filterEmpty[0])
    //console.log(list)
    filterEmpty = categoryPages.filter((page) => {
      //console.log(page)
      return page.pageId !== val;
    });
    //console.log(filterEmpty)

    setPages(list)
    setCategoryPages(filterEmpty)
  }

  var title = <>類別{categoryId === "" ? "新增" : "編輯"}</>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"名稱"} val={categoryName} action={setCategoryName} placeholder={"外部員工、薪資計算"} size={4} />

        </div>
      </div>
      <div className="hr-line-dashed"></div>
      {type !== "Page" ? <></> :
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-5">
              <p>擁有頁面</p>
              <select className="form-control" multiple="multiple" size="10">
                {
                  categoryPages.map(page => (
                    <option key={page.pageId} value={page.pageId} onClick={e => unChoose(e.target.value)}>{page.pageName} - {page.pageDescription}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-md-1">
            </div>
            <div className="col-md-5">
              <p>可選頁面</p>
              <select className="form-control" multiple="multiple" size="10">
                {
                  pages.map(page => (
                    <option key={page.pageId} value={page.pageId} onClick={e => choose(e.target.value)}>{page.pageName} - {page.pageDescription}</option>
                  ))
                }
              </select>
            </div>
          </div>
        </div>
      }
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}